import { boxShadow, color } from '@upstox/upstox-ui';
import { fonts } from '@upstox/upstox-ui/theme/light/fonts';

export const modalContainer: CSSFunction = () => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  fontFamily: fonts.tvFont,
});

export const minimizedContainer: CSSFunction = ({ theme }) => ({
  zIndex: 2,
  backgroundColor: color(theme, theme.colors.background.default4),
  boxShadow: boxShadow(theme, theme.modals.boxShadow),
  padding: '8px 24px 24px',
  cursor: 'move',
  position: 'absolute',
  lineHeight: '20px',
  bottom: '7%',
});

export const maximizedContainer: CSSFunction = ({ theme }) => ({
  zIndex: 2,
  background: color(theme, theme.modals.backgroundBackdrop),
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

export const base: CSSFunction = ({ theme }) => ({
    zIndex: 3,
    backgroundColor: color(theme, theme.colors.background.default4),
    boxShadow: boxShadow(theme, theme.modals.boxShadow),
    margin: 'auto',
    maxHeight: '100%',
    width: '70vw',
    height: '660px',
    overflow: 'hidden',
    padding: '8px 24px 24px',
    position: 'absolute',
    lineHeight: '20px',
  });

export const optionChainTableContainer: CSSFunction = () => ({
   overflowY: 'auto',
   height: '100%',
});

export const notAvailableContainer: CSSFunction = ({ theme }) => ({
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  border: `1px solid ${color(theme, 'ui3')}`,
  background: color(theme, 'ui7'),
  paddingTop: '116px',
});
